<app-form-base *ngIf="personForm" [formGroup]="personForm">
  <ng-container content>
    <app-edit-form-default (clickDelete)="deleteFormData()" *ngIf="!hasDefaultBillingInfo"></app-edit-form-default>
    <div class="billingForm__content-row">
      <p class="billingForm__content-row__title">{{'BOOKING_MODULE.BILLING.PERSONAL_INFO' | transloco}}</p>
      <div class="billingForm__content-row__inputs" #firstName>
        <app-form-text-input [ngStyle]="{ 'width': '50%', 'padding-right': '8px' }" [form]="personForm"
          [style]="'input-flex'" [formControlSelector]="firstNameControl" [id]="firstNameControl" [maxLength]="50"
          [isSubmitted]="isSubmitted" [formInputType]="onlyLettersInput"
          [placeholder]="'BOOKING_MODULE.FIRST_NAME' | transloco"
          (keyUp)="changeUpperCaseName($event, firstNameControl, personForm)" (click)="scroll(firstNameRef)">
        </app-form-text-input>
        <section #secondName [ngStyle]="{ 'width': '50%' }">
          <app-form-text-input [form]="personForm" [style]="'input-flex-margin'"
            [formControlSelector]="middleNameControl" [id]="middleNameControl" [maxLength]="50"
            [isSubmitted]="isSubmitted" [formInputType]="onlyLettersInput"
            [placeholder]="'BOOKING_MODULE.SECOND_NAME' | transloco"
            (keyUp)="changeUpperCaseName($event, middleNameControl, personForm)" (click)="scroll(secondNameRef)">
          </app-form-text-input>
        </section>
      </div>
    </div>

    <div class="billingForm__content-row">
      <div class="billingForm__content-row__inputs" #lastName>
        <app-form-text-input [ngStyle]="{ 'width': '100%' }" [form]="personForm" [formControlSelector]="lastNameControl"
          [id]="lastNameControl" [maxLength]="50" [isSubmitted]="isSubmitted" [formInputType]="onlyLettersInput"
          [placeholder]="'BOOKING_MODULE.LAST_NAMES' | transloco"
          (keyUp)="changeUpperCaseName($event, lastNameControl, personForm)" (click)="scroll(lastNameRef)">
        </app-form-text-input>
      </div>
    </div>

    <div class="billingForm__content-row">
      <div class="billingForm__content-row__inputs inline document-selector" #documentNumber>
        <app-form-document-input #documentSelectorRef
          [form]="personForm"
          [documents]="documents$ | async"
          [isSubmitted]="isSubmitted"
          [travelerBookingProvider]="bookingType"
          [documentNumberSelector]="documentNumberSelector"
          [configurationDocumentId]="configurationDocumentId"
          [type]="type"
          [defaultDocument]="defaultDocument$ | async"
          [validators]="formDocumentValidations$ | async"
          [documentType]="documentType$ | async"
          [isMobile]="isMobile"
          (documentSelected)="onDocumentTypeSelected($event)">
        </app-form-document-input>
      </div>
    </div>

    <app-address-form #addressFormRef
      [form]="personForm"
      [countries]="countries"
      [cities]="cities"
      [isActiveForm]="true"
      [isSubmitted]="isSubmitted"
      [disabledCountryOptions]="disabledCountryOptions"
      [userAddresses]="userAddresses"
      [defaultBilling]="defaultBilling"
      [selectedCityCode]="selectedCityCode"
      [isMobile]="isMobile"
      (selectedCountry)="selectedCountry($event)"
      (selectedCity)="selectedCity($event)">
    </app-address-form>

    <div class="billingForm__content-row" *ngIf="!disabledFiscalResponsibility" #fiscalResponsability>
      <div class="billingForm__content-row__inputs">
        <app-form-text-input [ngStyle]="{ 'width': '100%' }" [form]="personForm"
          [formControlSelector]="fiscalResponsibilityControl" [id]="fiscalResponsibilityControl"
          [placeholder]="'BOOKING_MODULE.FISCAL_RESPONSIBILITY' | transloco" [readOnly]="true"
          (keyUp)="changeUpperCaseName($event, fiscalResponsibilityControl, personForm)"
          (click)="scroll(fiscalResponsability)">
        </app-form-text-input>
      </div>
    </div>

    <div class="billingForm__content-row input-checkbox" *ngIf="!hasDefaultBillingInfo">
      <div class="billingForm__content-row__inputs">
        <fieldset class="checkbox">
          <legend>{{'BOOKING_MODULE.BILLING.SAVE_IN_THE_LIST' | transloco}}</legend>
          <input id="add-person-list" [checked]="saveFormData" autocomplete="off" maxlength="50" type="checkbox"
            (click)="setSaveFormData()">
          <label for="add-person-list" class="last-name">{{'BOOKING_MODULE.BILLING.SAVE_IN_THE_LIST' |
            transloco}}</label>
        </fieldset>
      </div>
    </div>
  </ng-container>

  <ng-container button>
    <ng-container *ngIf="isMobile; else desktopPersonBtn">
      <app-fixed-surface>
        <ng-container *ngTemplateOutlet="buttonPersonalBilling"></ng-container>
      </app-fixed-surface>
    </ng-container>
  
    <ng-template #desktopPersonBtn>
      <div class="billingForm__button__desktop">
        <ng-container *ngTemplateOutlet="buttonPersonalBilling"></ng-container>
      </div>
    </ng-template>

    <ng-template #buttonPersonalBilling>
      <app-ds-button
        [labels]="{ ButtonLabel: 'BOOKING_MODULE.BILLING.SAVE' | transloco }"
        (clickEvent)="save()">
      </app-ds-button>
    </ng-template>
  </ng-container>

</app-form-base>
